const KEY = "hc_order_snapshots";
const MAX = 10;

export function saveOrderSnapshot(orderNumber, snapshot) {
  try {
    const all = JSON.parse(sessionStorage.getItem(KEY)) || {};
    all[orderNumber] = snapshot;
    const keys = Object.keys(all).slice(-MAX);
    sessionStorage.setItem(KEY, JSON.stringify(Object.fromEntries(keys.map((k) => [k, all[k]]))));
  } catch { /* storage unavailable */ }
}

export function getOrderSnapshot(orderNumber) {
  try {
    const all = JSON.parse(sessionStorage.getItem(KEY)) || {};
    return all[orderNumber] || null;
  } catch { return null; }
}
